"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Select = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Select"));
var _context = require("../../../../services/currency/context");
var _Currency = require("../../../../records/Currency");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CurrencySelect = _ref => {
  let {
    currencyId,
    setCurrency
  } = _ref;
  const {
    available
  } = (0, _context.useCurrency)();
  const availableList = (0, _Currency.getAvailableList)(available);
  const currencyOptions = availableList.map(currency => ({
    value: currency.id,
    label: `${currency.name} - ${currency.code}`
  }));
  const onSetCurrency = e => {
    const {
      value
    } = e.target;
    setCurrency(value);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
    dataTest: "CurrencySelect",
    label: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
      id: "account.regional_settings_modal.section.currency"
    })),
    onChange: onSetCurrency,
    options: currencyOptions,
    value: currencyId
  });
};
var _default = exports.default = CurrencySelect;